/*eslint-disable */
import React, { Component } from "react";
import AgGridTable from "../../../components/common/asyncAgGridTable";
import ReadAxios from "../../../components/axiosComponent/read";
import { isEmpty } from "lodash";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { FEATURES } from "../../../utils/constant";

class VendorShare extends Component {
  state = {
    rowData: [],
    loadingData: true,
  };
  componentDidMount() {
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API_TWO}/vendor/share`,
    })
      .then((dataArray) => {
        this.setState({
          loadingData: false,
          rowData: isEmpty(dataArray)
            ? this.setState({ rowData: [], loadingData: false })
            : dataArray.data.resultSet,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loadingData: false, rowData: [] });
      });
  }

  componentWillReceiveProps(nextProps) {
    console.log(nextProps);
  }

  OnpaginationChangeCallback = async (event) => {
    console.log('here');
    let result = [];
    let apiDataJSON = [];
    const agGridPageSize = event.api.paginationProxy.pageSize;
    const agGridCurrentPage = event.api.paginationProxy.currentPage;
    const agGridPageTotalData = this.state.rowData;
    const agGridPageinationData = agGridPageTotalData.chunk(agGridPageSize);
    const agGridCurrentPageData = agGridPageinationData[agGridCurrentPage];
    // prepare data to make api call and merge it with row Data
    apiDataJSON = agGridPageTotalData.map((item) => {
      return {
        route_id: item.route_id,
        vehicle_id: item.vehicle_type_id,
      };
    });
    let agGridCurrentPageFetch = [];
    // Map and Async/Await is not a good idea.
    for (const item of apiDataJSON) {
      let routeManager = (await ReadAxios({ url: `routeManager/${item.route_id}` })) || [];
      let vehicleTypeManager =  (await ReadAxios({ url: `vehicleTypeMaster/${item.vehicle_id}` })) || [];
      routeManager = isEmpty(routeManager) ? [] : routeManager.data.resultSet;
      vehicleTypeManager = isEmpty(vehicleTypeManager) ? [] : vehicleTypeManager.data.resultSet;
      agGridCurrentPageFetch.push({
        source: routeManager[0].checkPointName,
        source_id: routeManager[0].checkPointId,
        destination: routeManager[routeManager.length - 1].checkPointName,
        destination_id: routeManager[routeManager.length - 1].checkPointId,
        vehicle_type: vehicleTypeManager[0]
          ? vehicleTypeManager[0].vehicleType
          : "",
        pending_share: "100%",
      });
      if (
        agGridCurrentPageFetch.length == agGridCurrentPageData.length &&
        JSON.stringify(this.state.paginationCallbackData) !=
          JSON.stringify(agGridCurrentPageFetch)
      ) {
        this.setState(
          {
            paginationCallbackData: agGridCurrentPageFetch,
            chunkedRowData: agGridPageinationData,
            currentPageData: agGridCurrentPageData,
            currentPageNumber: agGridCurrentPage,
            agGridPageSize: agGridPageSize,
          },
          () => {
            console.log("set state 161");
            this.mergeTheCallbackDataWithRowData();
          }
        );
      }
    }
  };

  mergeTheCallbackDataWithRowData = () => {
    let currentPageNumber = this.state.currentPageNumber;
    let pageSize = this.state.agGridPageSize;
    let rowData = this.state.rowData;
    let currnetFetchData = this.state.paginationCallbackData;
    let currentPageData = this.state.currentPageData;
    console.log(currentPageData);
    let tempRowData = currentPageData.map((item, index) => {
      return Object.assign({}, item, currnetFetchData[index]);
    });
    let startIndex = currentPageNumber * pageSize;
    rowData.splice(startIndex, pageSize, ...tempRowData);
    const { componentRenderKey } = this.state;
    this.setState(
      {
        rowData: rowData,
        componentRenderKey: componentRenderKey + 1,
      },
      () => console.log("set state 147")
    );
  };

  onCellClicked = (rowData) => {
    console.log(rowData);
    typeof rowData.value != "undefined" && this.onRowEdit(rowData.data);
  };

  onRowEdit = (rowData) => {
    this.props.history.push("/edit-vendor-share", {
      ...rowData,
      title: "edit_title",
    });
  };

  onRowDelete = (alert) => {
    if (alert.type === "success") this.props.successAlert(alert);
    else this.props.errorAlert(alert);
    this.props.history.push("/vendor-share");
    this.props.history.go();
  };

  render() {
    const { t } = this.props;
    const customerNo = localStorage.getItem('customerNumber')

    const Columns = [
      { headerName: t("table_header.source") || "Source", field: "source" },
      {
        headerName: t("table_header.destination") || "Destination",
        field: "destination",
      },
      {
        headerName: t("table_header.vehicle_type") || "Vehicle Type",
        field: "vehicle_type",
      },
      // {
      //   headerName: t("table_header.pending_share") || "Pending Share",
      //   field: "pending_share",
      // },
      {
        headerName: t("table_header.created_by") || "Created By",
        field: "createdBy",
      },
      {
        headerName: t("table_header.created_on") || "Created On",
        field: "createdOn",
      },
      {
        headerName: t("table_header.modified_by") || "Modified By",
        field: "updatedBy",
      },
      {
        headerName: t("table_header.modified_on") || "Modified On",
        field: "updatedOn",
      },
      {
        headerName: t(customerNo != 1158 ? "table_header.vendor_share" : "table_header.partner_share") || "Vendor Share",
        field: "view",
        cellRenderer: "detailRenderer",
        suppressToolPanel: true,
      },
      {
        headerName: t("table_header.edit_delete") || "Edit / Delete",
        field: "edit",
        cellRenderer: "actionRenderer",
        pinned: "right",
        suppressToolPanel: true,
      },
    ];
    const { rowData } = this.state;
    return (
      <React.Fragment>
        <AgGridTable
          isLoading={this.state.loadingData}
          columnDefs={Columns}
          rowData={rowData}
          titleBarTitle={t(customerNo != 1158 ? "vendor_title" : "title") || "Vendor Share"}
          titleBarLink={"/add-vendor-share"}
          completeURL={`${process.env.REACT_APP_MASTER_API_TWO}/vendor/share`}
          keyIndex={"vendor_share_id"}
          onEdit={this.onRowEdit}
          hideRowEdit={true}
          // cellDoubleClicked={this.onCellClicked}
          onDelete={this.onRowDelete}
          OnpaginationChangeCallback={this.OnpaginationChangeCallback}
          exportHidden={FEATURES.mastersExportDisabled()}
          suppressExcelExport={FEATURES.mastersExportDisabled()}
          suppressCsvExport={FEATURES.mastersExportDisabled()}
        />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
    errorAlert: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(
  null,
  mapDispatchToProps
)(translate("vendor_share")(VendorShare));
